export const REDUX_SLICE = {
  APP: 'app',
  PROJECT: 'project',
  CLAIM_GALA_API: 'claimGalaApi',
  PRICE_API: 'priceApi',
  PROJECT_API: 'projectApi',
  REDEEM_API: 'redeemApi',
  REFERRAL_API: 'referralApi',
  REWARD_API: 'rewardApi',
  OTC_API: 'otcApi',
} as const;
